import React from 'react'
import _ from 'lodash'
import { P } from 'konsys-ui'
import contents from './detail/contents'
import CompoenentRenderer from './detail/component-renderer'
import { Wrapper } from '../../components/truckowner-components'
import { detailMode } from './constants'
import history from '../../history'

const RowRenderer = ({
  data, mode, onChangeHandler, initialData, mutationVariables, disabled,
}) => data.map(v => <CompoenentRenderer
    onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
    key={v.id}
    data={v}
    mode={mode}
    initialData={initialData}
    mutationVariables={mutationVariables}
    disabled={disabled}
  />)

const DetailModeHandler = (params, onChangeHandler, mutationVariables, initialData) => {
  const mode = params.mode.toUpperCase()
  switch (mode) {
    case detailMode.ADD:
      return contents.map((v, i) => (
      <Wrapper key={i}>
        <RowRenderer data={v}
        mode={mode}
        onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
        mutationVariables={mutationVariables}/>
      </Wrapper>))
    case detailMode.EDIT:
    {
      if (_.isUndefined(params.id)) history.push('/truckowner')
      return contents.map((v, i) => (<Wrapper key={i}>
        <RowRenderer data={v}
        mode={mode}
        onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
        mutationVariables={mutationVariables}
        initialData={initialData}
        />
      </Wrapper>))
    }
    case detailMode.VIEW:
    {
      if (_.isUndefined(params.id)) history.push('/truckowner')
      // mockup data
      return contents.map((v, i) => (<Wrapper key={i}>
        <RowRenderer data={v}
        mode={mode}
        disabled={false}
        onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
        mutationVariables={mutationVariables}
        initialData={initialData}
        />
      </Wrapper>))
    }
    default:
      return <P>Something went wrong!</P>
  }
}

export default DetailModeHandler
